import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import './Quiz.css';
import LogoutTimer from './LogoutTimer';
import useAuth from '../../hooks/useAuth.js';
import Swal from 'sweetalert2';
import dataEngineerQ from './DataEngineerQ.js';
import Input from 'antd/es/input/Input.js';
import sqlQ from './sqlQ.js';
// import { type } from 'os';

const URL = process.env.REACT_APP_API_URL;

const BigQueryTest = () => {
    const { auth } = useAuth();
    const { TextArea } = Input;
    const navigate = useNavigate();
    const [activeQuestion, setActiveQuestion] = useState(0)
    // const [selectedAnswer, setSelectedAnswer] = useState('')
    const [showResult, setShowResult] = useState(false);
    // const [sqlQuestions, setSQLQuestions] = useState();
    const [answer, setAnswer] = useState('');
    // const [corrAnswer, setCorrAnswer] = useState('');
    // const [selectedAnswerIndex, setSelectedAnswerIndex] = useState(null)
    const [quizFinished, setQuizFinished] = useState(false);


    const shuffleArray = (arr) => arr.sort(() => 0.5 - Math.random());

    // useEffect(() => {

    // })

    const [result, setResult] = useState([]);
    const totalQuestions = 4;
    const combinedQuestions = useMemo(() => {
        const selectedSql = shuffleArray(sqlQ.sqlQuestionss).slice(0, 2).map(q => ({ ...q, type: 'sql' }));
        const selectedBigQuery = shuffleArray(dataEngineerQ.questions).slice(0, 2).map(q => ({ ...q, type: 'dataEngineer' }));
        return shuffleArray([...selectedSql, ...selectedBigQuery]);
    }, []);

    // const { questions } = dataEngineerQ;
    // const { sqlQuestionss } = sqlQ;

    const currentQuestion = combinedQuestions[activeQuestion];
    const { questionId, question, correctAnswer } = currentQuestion || {};

    const onClickNext = () => {

        if (!combinedQuestions[activeQuestion]) return;

        // console.log('activeQuestion: ', activeQuestion);

        setResult(prev => [...prev, { questionId, question, answer }]);

        // console.log('result: ', result);

        // if (activeQuestion === questions.length - 1) {
        if (activeQuestion < totalQuestions - 1) {
            setActiveQuestion((prev) => prev + 1)
        } else {
            setActiveQuestion(0)
            setShowResult(true)
            setQuizFinished(true)
        }
        setAnswer('');
    }

    const Id = (auth._id);

    const updateBigQuery = useCallback(() => {

        const status = "Attempted";

        const updatedResult = {
            big_Query: {
                // score: correctAnswers,
                answers: result,
                status: status
            },
        };

        fetch(`${URL}/api/candidate/${Id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(updatedResult),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'SUCCESS') {
                    navigate('/candidate/candidate');
                } else {
                    console.error('Failed to update candidate record:', data.message);
                }
            })
            .catch((error) => {
                console.error('Failed to update candidate record:', error);
            });
    }, [result, combinedQuestions, navigate, Id]);

    const handleChange = (e) => {
        const newVal = e.target.value;
        // console.log('newVal: ', newVal);

        setAnswer(newVal);
        // console.log('answer (will show previous): ', answer);
    }

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'hidden') {
                updateBigQuery();
                Swal.fire({
                    title: 'As You have navigated from Assessment Page',
                    text: "Big Query Test has been Disabled",
                    icon: 'error',
                    showCloseButton: true,
                    confirmButtonColor: '#00B4D2',
                    confirmButtonText: 'Ok'
                })
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [updateBigQuery]);

    const addLeadingZero = (number) => (number > 9 ? number : `0${number}`)

    return (
        <div className="quiz-container">
            <div className='heading-timer'>
                <center><h1 style={{ fontSize: "22px" }}>Big Query Test</h1></center><br />
                {!quizFinished && <LogoutTimer initialTimer={4500} />}
            </div>

            {!showResult ? (
                <div>
                    <div>
                        <span className="active-question-no">
                            {addLeadingZero(activeQuestion + 1)}
                        </span>
                        <span className="total-question">
                            /{addLeadingZero(combinedQuestions.length)}
                        </span>
                    </div>
                    {currentQuestion ? (
                        <>
                            {(currentQuestion.questionId === 11 || currentQuestion.questionId === 12 || currentQuestion.questionId === 13 || currentQuestion.questionId === 14) &&
                                <>
                                    <h1 style={{ fontWeight: 'bold', color: '#00B4D2', marginTop: '20px', marginBottom: '10px' }}>Given Below are 4 tables: </h1>
                                    <div style={{ fontWeight: 'bold', color: '#00B4D2', marginTop: '20px', marginBottom: '10px' }}>
                                        {sqlQ.tables.map((table, index) => (
                                            <h1 style={{ fontWeight: 'bold', color: '#00B4D2', marginTop: '20px', marginBottom: '10px' }} key={index}>
                                                {table}
                                            </h1>
                                        ))}
                                    </div>
                                </>
                            }

                            <h1 style={{ fontWeight: 'bold', color: '#00B4D2', marginTop: '20px', marginBottom: '10px' }}>{currentQuestion.question}</h1>
                            <ul>
                                <TextArea
                                    rows={25} // you can adjust the number of visible rows
                                    placeholder="Enter your answer here"
                                    maxLength={1000}
                                    value={answer || ''}
                                    spellCheck={true}
                                    lang="en"
                                    onChange={handleChange}
                                />
                            </ul>
                            <div className="flex-right">

                                <button
                                    onClick={onClickNext}
                                    disabled={answer === ''}>
                                    {activeQuestion === totalQuestions - 1 ? 'Finish' : 'Next'}
                                    {/* {activeQuestion === questions.length - 1 ? 'Finish' : 'Next'} */}
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            <h3>Loading Question...</h3>
                        </>
                    )}
                </div>
            ) :
                (
                    <div className="click-finish">
                        <button className='redirect' onClick={updateBigQuery}>
                            Go back To Assessment Page
                        </button>
                    </div>
                )
            }
        </div>
    )
}

export default BigQueryTest;